import React from 'react';
import styled from 'styled-components';
import { I18n, Translate } from 'react-redux-i18n';

const LegalNoticeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: -130px;
  margin-right: -40px;
  background-color: white;
  padding-top: 50px;
  padding-left: 20%;
  padding-right: 20%;
  padding-bottom: 100px;
  margin-bottom: -40px;
  flex: 1;
  overflow-y: auto;

  > div:not(:last-child) {
    margin-bottom: 50px;
  }

  h1 {
    text-transform: uppercase;
    line-height: 1.25;
    font-size: 24px;
    font-family: ${(props) => props.theme.fonts.sfcompact_light};
    margin-bottom: 10px;
    width: 100%;
    text-align: center;
  }

  p {
    line-height: 2;
    font-size: 14px;
    font-family: ${(props) => props.theme.fonts.sfcompact};
    color: ${(props) => props.theme.colors.dark};
  }

  h2 {
    line-height: 2;
    font-size: 18px;
    font-family: ${(props) => props.theme.fonts.sfcompact_semibold};
    margin-bottom: 40px;
    text-decoration: underline;
  }

  h3 {
    line-height: 2;
    font-size: 16px;
    font-family: ${(props) => props.theme.fonts.sfcompact};
    margin-bottom: 20px;
    text-decoration: underline;
    margin-left: 40px;
    margin-top: 20px;
  }

  a {
    font-family: ${(props) => props.theme.fonts.sfcompact_semibold};
    color: ${(props) => props.theme.colors.dark};
    text-decoration: none;
  }

  i {
    font-style: italic;
  }

  a:hover {
    opacity: 0.8;
    cursor: pointer;
  }

  b {
    font-weight: bold !important;
  }

  td:first-child {
    padding-right: 15px;
  }

  .dash {
    list-style-type: '- ';
  }
`;

const LegalNotice = () => (
  <LegalNoticeContainer>
    {/* CONDITIONS GENERALES D’UTILISATION */}
    <h1>
      {I18n.t('legalMention.title1')}
      <br />
      {/* DE LA PLATEFORME « My app Wine Services » */}
      {I18n.t('legalMention.title2')}
      <br />
      {/* Version datée du 22/01/2024 */}
      <p style={{ fontSize: 20, marginTop: 20 }}>
        {I18n.t('legalMention.date')}
      </p>
    </h1>
    {/* PROPRIETAIRE ET EDITEUR DE LA PLATEFORME */}
    <div>
      <h2>{I18n.t('legalMention.property.title')}</h2>
      <div style={{ marginLeft: 15 }}>
        <p>
          {/* Dénomination sociale : WINE SERVICES */}-{' '}
          {I18n.t('legalMention.property.denomination')}
          <br />
          {/* Forme juridique : société par actions simplifiée */}-{' '}
          {I18n.t('legalMention.property.legalForm')}
          <br />
          {/* Montant du capital social : 50.000 € */}-{' '}
          {I18n.t('legalMention.property.capital')}
          <br />
          {/* Numéro d’immatriculation au Registre du Commerce... */}-{' '}
          {I18n.t('legalMention.property.registration')}
          <br />
          {/* Adresse du siège social : 20 Quai de Bacalan... */}-{' '}
          {I18n.t('legalMention.property.address')}
          <br />
          {/* Coordonnées de contact : info@wine-services.com... */}-{' '}
          {I18n.t('legalMention.property.contact')} :&nbsp;
          <a href="mailto:info@wine-services.com">
            info@wine-services.com
          </a> / {I18n.t('legalMention.property.phone')}
          <br />
          {/* Numéro de TVA Intracommunautaire : FR93520132069 */}-{' '}
          {I18n.t('legalMention.property.tva')}
          <br />
          {/* Directeur de la publication : Caroline MEESEMAECKER */}-{' '}
          {I18n.t('legalMention.property.direction')}
        </p>
      </div>
    </div>
    {/* HEBERGEUR DE LA PLATEFORME */}
    <div>
      <h2>{I18n.t('legalMention.hosting.title')}</h2>
      <div style={{ marginLeft: 15 }}>
        <p>
          {/* Raison sociale : HEROKU (Salesforce.com France) */}-{' '}
          {I18n.t('legalMention.hosting.denomination')}
          <br />
          {/* Adresse : 3 Avenue Octave Gréard, 75007 PARIS (France) */}-{' '}
          {I18n.t('legalMention.hosting.address')}
          <br />
          {/* Coordonnées de contact : 01 72 10 94 00 */}-{' '}
          {I18n.t('legalMention.hosting.contact')}
        </p>
      </div>
      <br />
      {/* Les présentes conditions générales d’utilisation... */}
      <p>
        <Translate value="legalMention.hosting.rules" dangerousHTML />
      </p>
      <br />
      {/* Ces dernières sont complétées par les conditions générales... */}
      <p>
        <Translate value="legalMention.hosting.cgv" dangerousHTML />
      </p>
      <br />
      {/* Toute connexion à cette dernière implique... */}
      <p>{I18n.t('legalMention.hosting.connexion')}</p>
    </div>
    {/* Article 1. DEFINITIONS */}
    <div>
      <h2>{I18n.t('legalMention.definition.title', { index: '1' })}</h2>
      {/* Les termes débutant par une majuscule... */}
      <p>{I18n.t('legalMention.definition.content')} :</p>
      <br />
      <table>
        <tbody>
          {/* «Administrateur(s)» */}
          <tr>
            <td>
              <p>
                <b>{I18n.t('legalMention.definition.table.admin.title')}</b>
              </p>
            </td>
            {/* «désigne la ou les personne(s) physiques...  */}
            <td>
              <p style={{ marginBottom: 15 }}>
                {I18n.t('legalMention.definition.table.admin.body')}
              </p>
            </td>
          </tr>
          {/* «Client» */}
          <tr>
            <td>
              <p>
                <b>{I18n.t('legalMention.definition.table.customer.title')}</b>
              </p>
            </td>
            {/* désigne la personne morale, ayant souscrit... */}
            <td>
              <p style={{ marginBottom: 15 }}>
                {I18n.t('legalMention.definition.table.customer.body')}
              </p>
            </td>
          </tr>
          {/* «Compte» */}
          <tr>
            <td>
              <p>
                <b>{I18n.t('legalMention.definition.table.account.title')}</b>
              </p>
            </td>
            {/* désigne tout compte associé à un Utilisateur... */}
            <td>
              <p style={{ marginBottom: 15 }}>
                {I18n.t('legalMention.definition.table.account.body')}
              </p>
            </td>
          </tr>
          {/* «Contenu(s)» */}
          <tr>
            <td>
              <p>
                <b>{I18n.t('legalMention.definition.table.content.title')}</b>
              </p>
            </td>
            {/* désigne - sans que cette liste ne soit limitative... */}
            <td>
              <p style={{ marginBottom: 15 }}>
                {I18n.t('legalMention.definition.table.content.body')}
              </p>
            </td>
          </tr>
          {/* «Plateforme» */}
          <tr>
            <td>
              <p>
                <b>{I18n.t('legalMention.definition.table.platform.title')}</b>
              </p>
            </td>
            {/* désigne la plateforme de market intelligence */}
            <td>
              <p style={{ marginBottom: 15 }}>
                {I18n.t('legalMention.definition.table.platform.body')}
                <a
                  href="https://myapp.wine-services.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://myapp.wine-services.com
                </a>
                .
              </p>
            </td>
          </tr>
          {/* «Utilisateur» */}
          <tr>
            <td>
              <p>
                <b>{I18n.t('legalMention.definition.table.user.title')}</b>
              </p>
            </td>
            {/* désigne la personne physique, employée du Client... */}
            <td>
              <p style={{ marginBottom: 15 }}>
                {I18n.t('legalMention.definition.table.user.body')}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    {/* Article 2. OBJET */}
    <div>
      <h2>{I18n.t('legalMention.object.title', { index: '2' })}</h2>
      {/* La Plateforme a pour objectif de permettre... */}
      <p>{I18n.t('legalMention.object.purpose')}</p>
      <br />
      {/* A date d’effet des présentes CGU... */}
      <p>{I18n.t('legalMention.object.wsServices')}</p>
      <br />
      <div style={{ marginLeft: 15 }}>
        <p>
          {/* Accès aux informations des cartes... */}-{' '}
          {I18n.t('legalMention.object.services.information')}
          <br />
          {/* Visualisation de la présence des vins du Client... */}-{' '}
          {I18n.t('legalMention.object.services.visualization')}
          <br />
          {/* Identification du positionnement du Client... */}-{' '}
          {I18n.t('legalMention.object.services.identification')}
          <br />
          {/* Suivi régulier des points majeurs de vente en ligne... */}-{' '}
          {I18n.t('legalMention.object.services.monitoring')}
          <br />
          {/* Veille médiatique (presse papier/digitale, France, mondial... */}-{' '}
          {I18n.t('legalMention.object.services.media')}
          <br />
          {/* Accès aux notes de dégustation des journalistes... */}-{' '}
          {I18n.t('legalMention.object.services.tasting')}
        </p>
      </div>
      <br />
      {/* Cette liste est non exhaustive et peut être modifiée... */}
      <p>{I18n.t('legalMention.object.exhaustiveList')}</p>
    </div>
    {/* Article 3. ACCES A LA PLATEFORME */}
    <div>
      <h2>{I18n.t('legalMention.platform.title', { index: '3' })}</h2>
      {/* Toute connexion à la Plateforme par l’Utilisateur... */}
      <div>
        <p>{I18n.t('legalMention.platform.acceptance')}</p>
        <br />
        {/* La Plateforme est accessible à l’adresse... */}
        <p>
          <Translate
            value="legalMention.platform.accessibility1"
            dangerousHTML
          />
          {I18n.t('legalMention.platform.accessibility2')}
        </p>
        <br />
        {/* WINE SERVICES rappelle à chaque Utilisateur... */}
        <p>
          <Translate value="legalMention.platform.confidential" dangerousHTML />
        </p>
      </div>
      {/* Création de Compte et première connexion */}
      <div>
        <h3>a) {I18n.t('legalMention.platform.account.title')}</h3>
        {/* Afin d’accéder à la Plateforme... */}
        <p>{I18n.t('legalMention.platform.account.content')} :</p>
        <br />
        <p style={{ marginLeft: 20 }}>
          <ul className="dash">
            {/* Nom et prénom */}
            <li>{I18n.t('legalMention.platform.account.lists.name')}</li>
            {/* Adresse électronique */}
            <li>{I18n.t('legalMention.platform.account.lists.address')}</li>
            {/* Outils et fonctionnalités de la Plateforme... */}
            <li>{I18n.t('legalMention.platform.account.lists.tools')}</li>
          </ul>
        </p>
        <br />
        {/* Après vérifications de l’Administrateur... */}
        <p>{I18n.t('legalMention.platform.account.checks')}</p>
      </div>
      {/* Oubli ou perte des mots de passe */}
      <div>
        <h3>b) {I18n.t('legalMention.platform.password.title')}</h3>
        {/* En cas d'oubli ou de perte de mots de passe... */}
        <p>
          <Translate
            value="legalMention.platform.password.content"
            dangerousHTML
          />
        </p>
      </div>
      {/* Suppression de l'accès et de Compte */}
      <div>
        <h3>c) {I18n.t('legalMention.platform.deleteAccount.title')}</h3>
        {/* Si l'Utilisateur souhaite supprimer son Compte... */}
        <p>{I18n.t('legalMention.platform.deleteAccount.content')}</p>
      </div>
    </div>
    {/* Article 4. PROPRIETE INTELLECTUELLE */}
    <div>
      <h2>
        {I18n.t('legalMention.intellectualProperty.title', { index: '4' })}
      </h2>
      {/* Les éléments constituant ou figurant dans la Plateforme... */}
      <p>{I18n.t('legalMention.intellectualProperty.contents')}</p>
      <br />
      {/* WINE SERVICES est propriétaire exclusif... */}
      <p>
        {I18n.t('legalMention.intellectualProperty.property1')}
        <br />
        {I18n.t('legalMention.intellectualProperty.property2')}
      </p>
      <br />
      {/* Aucune des dispositions des CGU ne peut être interprétée... */}
      <p>{I18n.t('legalMention.intellectualProperty.provisions')}</p>
      <br />
      {/* En exécution de la relation contractuelle conclue... */}
      <p>
        <Translate
          value="legalMention.intellectualProperty.usageRights"
          dangerousHTML
        />
      </p>
      <br />
      {/* En conséquence, il est rappelé, qu’en l’absence... */}
      <p>{I18n.t('legalMention.intellectualProperty.authorisation')} :</p>
      <br />
      <p style={{ marginLeft: 20 }}>
        <ul className="dash">
          {/* De représenter ou reproduire tout ou partie la Plateforme */}
          <li>
            {I18n.t('legalMention.intellectualProperty.list.representation')}
          </li>
          {/* De procéder à la traduction, l'adaptation */}
          <li>
            {I18n.t('legalMention.intellectualProperty.list.translation')}
          </li>
          {/* De procéder à la compilation, décompilation... */}
          <li>
            <Translate
              value="legalMention.intellectualProperty.list.compilation"
              dangerousHTML
            />
          </li>
          {/* D’extraire ou de réutiliser, à quelque fin que ce soit... */}
          <li>{I18n.t('legalMention.intellectualProperty.list.reuse')}</li>
          {/* De créer des œuvres dérivées de tout ou partie... */}
          <li>{I18n.t('legalMention.intellectualProperty.list.derivation')}</li>
          {/* De mettre sur le marché, distribuer, commercialiser... */}
          <li>{I18n.t('legalMention.intellectualProperty.list.marketing')}</li>
        </ul>
      </p>
      <br />
      {/* Enfin, l'Utilisateur s'engage expressément... */}
      <p>{I18n.t('legalMention.intellectualProperty.contentsRights')}</p>
    </div>
    {/* Article 5. CONFIDENTIALITE */}
    <div>
      <h2>{I18n.t('legalMention.confidentiality.title', { index: '5' })}</h2>
      {/* L’Utilisateur s’engage à prendre toutes les précautions... */}
      <p>{I18n.t('legalMention.confidentiality.precautions')}</p>
      {/* En particulier, il s’engage notamment à faire... */}
      <p>{I18n.t('legalMention.confidentiality.deformations')}</p>
      <br />
      {/* Cet engagement de confidentialité de l’Utilisateur... */}
      <p>{I18n.t('legalMention.confidentiality.confidentialityAgreement')}</p>
    </div>
    {/* Article 6. SECURITE ET DISPONIBILITE DE LA PLATEFORME */}
    <div>
      <h2>{I18n.t('legalMention.security.title', { index: '6' })}</h2>
      {/* WINE SERVICES s'engage à faire ses meilleurs efforts... */}
      <p>{I18n.t('legalMention.security.security')}</p>
      <br />
      {/* A ce titre, l’Utilisateur s’interdit d’utiliser... */}
      <p>{I18n.t('legalMention.security.prohibition')}</p>
      <br />
      {/* La Plateforme est accessible 24 heures sur 24... */}
      <p>{I18n.t('legalMention.security.accessibility')}</p>
      {/* Les interventions de maintenance pourront être effectuées... */}
      <p>{I18n.t('legalMention.security.maintenance')}</p>
      {/* En outre, WINE SERVICES se réserve également le droit... */}
      <p>{I18n.t('legalMention.security.rightInterruption')}</p>
    </div>
    {/* Article 7. DONNEES A CARACTERE PERSONNEL */}
    <div>
      <h2>{I18n.t('legalMention.personalData.title', { index: '7' })}</h2>
      {/* En exécution du Contrat et dans le cadre de la fourniture... */}
      <p>
        <Translate value="legalMention.personalData.contracts1" dangerousHTML />
        <Translate value="legalMention.personalData.contracts2" dangerousHTML />
      </p>
      {/* Ces traitements sont effectués par WINE SERVICES en qualité... */}
      <p>{I18n.t('legalMention.personalData.treatments')}</p>
      <br />
      {/* Conformément à la règlementation applicable en matière... */}
      <p>{I18n.t('legalMention.personalData.accessData')}</p>
      <br />
      {/* Pour exercer leurs droits ou pour toute question... */}
      <p>
        {I18n.t('legalMention.personalData.processingData')}&nbsp;
        <a href="mailto:info@wine-services.com">info@wine-services.com</a>.
      </p>
      <br />
      {/* Enfin, chaque Utilisateur dispose également du droit... */}
      <p>{I18n.t('legalMention.personalData.claims')}</p>
    </div>
    {/* Article 8. COOKIES */}
    <div>
      <h2>{I18n.t('legalMention.cookies.title', { index: '8' })}</h2>
      {/* WINE SERVICES a recours à des cookies afin de faciliter... */}
      <p>{I18n.t('legalMention.cookies.use')}</p>
      <br />
      {/* Un « cookie » est un petit fichier d’information... */}
      <p>
        <Translate value="legalMention.cookies.definition" dangerousHTML />
      </p>
      <br />
      {/* Les Cookies peuvent poursuivre des objectifs différents... */}
      <p>
        {I18n.t('legalMention.cookies.purpose_1')}
        {I18n.t('legalMention.cookies.purpose_2')}
        {I18n.t('legalMention.cookies.purpose_3')}
      </p>
      <br />
      {/* WINE SERVICES est responsable de tous les Cookies... */}
      <p>{I18n.t('legalMention.cookies.responsibility')}</p>
      <br />
      {/* A ce titre, il est précisé que WINE SERVICE... */}
      <p>{I18n.t('legalMention.cookies.functioning')}</p>
      <br />
      {/* En toute autre circonstance, le consentement de l’Utilisateur... */}
      <p>{I18n.t('legalMention.cookies.consent')}</p>
      <br />
      {/* Une fois son choix effectué, il est possible.... */}
      <p>{I18n.t('legalMention.cookies.choises')}</p>
      <p style={{ marginLeft: 20 }}>
        <ul className="dash">
          <li>
            {I18n.t('legalMention.cookies.for')}
            &nbsp;Microsoft Edge™:&nbsp;
            <a
              href="https://support.microsoft.com/fr-fr/windows/g%C3%A9rer-les-cookies-dans-microsoft-edge-afficher-autoriser-bloquer-supprimer-et-utiliser-168dab11-0753-043d-7c16-ede5947fc64d"
              target="_blank"
              rel="noreferrer"
            >
              https://support.microsoft.com/fr-fr/windows/g%C3%A9rer-les-cookies-dans-microsoft-edge-afficher-autoriser-bloquer-supprimer-et-utiliser-168dab11-0753-043d-7c16-ede5947fc64d
            </a>
          </li>
          <li>
            {I18n.t('legalMention.cookies.for')}
            &nbsp;Safari™ :&nbsp;
            <a
              href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac"
              target="_blank"
              rel="noreferrer"
            >
              https://support.apple.com/fr-fr/guide/safari/sfri11471/mac
            </a>
          </li>
          <li>
            {I18n.t('legalMention.cookies.for')}
            &nbsp;Chrome™ :&nbsp;
            <a
              href="https://support.google.com/chrome/answer/95647?hl=fr&hlrm=en"
              target="_blank"
              rel="noreferrer"
            >
              https://support.google.com/chrome/answer/95647?hl=fr&hlrm=en
            </a>
          </li>
          <li>
            {I18n.t('legalMention.cookies.for')}
            &nbsp;Firefox™ :&nbsp;
            <a
              href="https://support.mozilla.org/fr/kb/effacer-cookies-donnees-site-firefox"
              target="_blank"
              rel="noreferrer"
            >
              https://support.mozilla.org/fr/kb/effacer-cookies-donnees-site-firefox
            </a>
          </li>
        </ul>
      </p>
    </div>
    {/* Article 9. RESPONSABILITE */}
    <div>
      <h2>{I18n.t('legalMention.responsibility.title', { index: '9' })}</h2>
      {/* Responsabilité de WINE SERVICES */}
      <div>
        <h3>
          a) {I18n.t('legalMention.responsibility.wsResponsibility.title')}
        </h3>
        <p>{I18n.t('legalMention.responsibility.wsResponsibility.content')}</p>
      </div>
      {/* Responsabilité des Utilisateurs */}
      <div>
        <h3>
          b) {I18n.t('legalMention.responsibility.userResponsibility.title')}
        </h3>
        <p>
          {I18n.t('legalMention.responsibility.userResponsibility.content')}
        </p>
      </div>
      {/* Convention de preuve */}
      <div>
        <h3>b) {I18n.t('legalMention.responsibility.prouf.title')}</h3>
        <p>{I18n.t('legalMention.responsibility.prouf.content')}</p>
      </div>
    </div>
    {/* Article 10. EVOLUTION DES CONDITIONS GENERALES D'UTILISATION */}
    <div>
      <h2>{I18n.t('legalMention.evolutionCGU.title', { index: '10' })}</h2>
      {/* Les CGU applicables sont celles en vigueur... */}
      <p>{I18n.t('legalMention.evolutionCGU.usable')}</p>
      {/* WINE SERVICES se réserve le droit de modifier... */}
      <p>{I18n.t('legalMention.evolutionCGU.update')}</p>
      {/* Les modifications éventuellement apportées par WINE SERVICES... */}
      <p>{I18n.t('legalMention.evolutionCGU.acceptance')}</p>
      <br />
      {/* WINE SERVICES invite donc tout Utilisateur à consulter... */}
      <p>{I18n.t('legalMention.evolutionCGU.invitation')}</p>
    </div>
    {/* Article 11. CONTACT */}
    <div>
      <h2>{I18n.t('legalMention.contact.title', { index: '11' })}</h2>
      {/* Toute question relative à la Plateforme... */}
      <p>
        {I18n.t('legalMention.contact.content')} :&nbsp;
        <a href="info@wine-services.com" target="_blank">
          info@wine-services.com
        </a>
        .
      </p>
    </div>
    {/* Article 12. LOI APPLICABLE */}
    <div>
      <h2>{I18n.t('legalMention.applicableLaw.title', { index: '12' })}</h2>
      {/* Les présentes CGU sont soumises à la loi française */}
      <p>{I18n.t('legalMention.applicableLaw.submissionLaw')}</p>
      <br />
      {/* Tout litige ou contestation relatif à l'exécution... */}
      <p>{I18n.t('legalMention.applicableLaw.dispute')}</p>
    </div>
  </LegalNoticeContainer>
);

export default LegalNotice;
